/**
 * Zdroje lidí v miniaplikaci Lidé — popisek čipu a termín volání.
 *
 * Popisek: dva zdroje téže školy (AD doména i Keycloak realm se jmenují
 * „ZŠ Horníkova“) se dřív lišily jen ikonou (ZSHACM001 2026-10-29). Čip proto
 * nese i druh zdroje: „ZŠ Horníkova · AD“. Entity druh nepotřebuje.
 */

export interface ChipSource {
  kind: string;
  label: string;
}

export function sourceChipLabel(source: ChipSource, kindShort: (kind: string) => string): string {
  const label = source.label.trim();
  if (source.kind === 'entity') return label;
  const kind = kindShort(source.kind).trim();
  if (!kind) return label;
  if (!label || label.toLowerCase() === kind.toLowerCase()) return kind;
  return `${label} · ${kind}`;
}

/** Výpis lidí nesmí čekat donekonečna: tool má 30 s, mesh hop a proxy něco navíc. */
export const PEOPLE_CALL_DEADLINE_MS = 45_000;

export class PeopleDeadlineError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'PeopleDeadlineError';
  }
}

/**
 * Po `ms` skončí chybou s čitelnou zprávou, i když odpověď nikdy nepřijde
 * (spadlé spojení, proxy bez odpovědi). Samotný požadavek se jen přestane čekat.
 */
export function withDeadline<T>(work: Promise<T>, ms: number, message: string): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  return Promise.race([
    work,
    new Promise<never>((_, reject) => {
      timer = setTimeout(() => reject(new PeopleDeadlineError(message)), ms);
    }),
  ]).finally(() => clearTimeout(timer));
}
